<template>
	<div>
		<input type="file" ref="file" @change="onFileUpload" style="display: none" />
		<div class="flex flex-row">
			<div class="flex-1 pr-4">
				<b-alert variant="danger" show v-if="errorFiles.length">{{
					$t("problem-uploading")
				}}</b-alert>

				<ul class="file-upload-list" v-if="files && !errorFiles">
					<li class="file-upload-list-item" v-for="file in files" :key="file.id">
						<div class="flex flex-row items-center">
							<div :class="getIconColor(file.name)">
								<b-icon :icon="getFileIcon(file.name)"></b-icon>
							</div>
							<div>
								<p class="font-bold">{{ file.name }}</p>
								<p class="text-xs">{{ file.type }} &middot; {{ file.size }}</p>
							</div>
						</div>
						<p>
							<b-spinner
								small
								label="Spinning"
								style="width: 24px; height: 24px"
								class="text-info"
							></b-spinner>
						</p>
					</li>
				</ul>

				<ul class="file-upload-list" v-if="uploadedFiles">
					<li class="file-upload-list-item" v-for="file in uploadedFiles" :key="file.id">
						<div class="flex flex-row items-center">
							<div :class="getIconColor(file.name)">
								<b-icon :icon="getFileIcon(file.name)"></b-icon>
							</div>
							<div>
								<p class="font-bold">{{ file.name }}</p>
								<p class="text-xs">{{ file.type }} &middot; {{ file.size }}</p>
							</div>
						</div>
						<p>
							<b-icon
								icon="cloud-check-fill"
								style="width: 24px; height: 24px"
								class="text-success"
							></b-icon>
						</p>
					</li>
				</ul>

				<ul class="file-upload-list" v-if="errorFiles">
					<li class="file-upload-list-item" v-for="file in errorFiles" :key="file.id">
						<div class="flex flex-row items-center">
							<div :class="getIconColor(file.name)">
								<b-icon :icon="getFileIcon(file.name)"></b-icon>
							</div>
							<div>
								<p class="font-bold">{{ file.name }}</p>
								<p class="text-xs">{{ file.type }} &middot; {{ file.size }}</p>
							</div>
						</div>
						<p>
							<b-icon
								icon="cloud-slash-fill"
								style="width: 24px; height: 24px"
								class="text-danger"
							></b-icon>
						</p>
					</li>
				</ul>
			</div>
			
			
			<!-- <div
				:class="
					uploadHover
						? 'file-upload-box file-upload-box-hover flex-1'
						: 'file-upload-box flex-1'
				"
				@click="openFileDialog"
				v-on:dragover.prevent="handleDragOver"
				v-on:drop.prevent="handleDrop"
				v-on:dragleave.prevent="handleDragLeave"
			>
				<div>
					<b-icon icon="cloud-upload" style="width: 80px; height: 80px;" class="mr-4" />
				</div>
				<div>
					<p class="mb-0 font-bold">Drag and drop</p>
					<p class="mb-0 font-italic">- or -</p>
					<p class="mb-0 font-bold">Click here</p>
				</div>
			</div> -->
			<div>
				<b-form-file
					multiple
					v-model="files"
					:state="Boolean(files)"
					:placeholder="$t('choose-file-or-drop-here-ellipses')"
					:drop-placeholder="$t('drop-file-here-ellipses')"
					accept=".doc, .docx, .pdf, .xls, .xlsx, .csv, .jpg, .jpeg, .gif, .png"
					ref="comment-files"
					data-cy="upload-file-input"
					@input="addFiles"
					class="mb-4"
				></b-form-file>
			</div>

		</div>
	</div>
</template>

<script>

export default {
	data: function () {
		return {
			files: [],
			uploadedFiles: [],
			errorFiles: [],
			uploadHover: false,

		};
	},
	props: {
		modalSettings: Object,
	},
	mounted() {
	},
	updated() {
		/*
		const uploadsRequired = this.files.find(file => !file.uploaded);

		if (uploadsRequired) {
			let data = new FormData();
			data.append("username", this.$UserSession.getValue.call(this, "username"));
			data.append("authToken", this.$UserSession.getValue.call(this, "authToken"));

			this.files.forEach(function(item, index) {
				data.append("files[" + index + "]", item.name);
			});

			fetch(`${this.$settings.APIBaseURL}/asset/upload`, {
				method: "post",
				body: data
			})
				.then(result => {
					if (result.status === 200) {
						result.json().then(json => {
							if (json.status === "SUCCESS") {
								this.uploadedFiles = [...this.files];

								this.files = [];
							} else {
								this.errorFiles = [...this.files];

								this.files = [];
							}
						});
					}
				})
				.catch(error => {
					this.$log.error.call(this, error);
					this.errorFiles = [...this.files];
					this.files = [];
				});
		}
		*/
	},
	methods: {
		openFileDialog() {
			this.$refs.file.click();
		},
		onFileUpload(e) {
			const { files } = e.target;

			if (files) {
				this.addFiles(files);
			}
		},
		addFiles() {
			var hasUploads = false;
			let data = new FormData();
			data.append("username", this.$UserSession.getValue.call(this, "username"));
			data.append("authToken", this.$UserSession.getValue.call(this, "authToken"));

			this.files.forEach(function (item, index) {
				//console.log(item);
				if(item){
					hasUploads = true;
					data.append("files[" + index + "]", item);
				}
			});

			if(hasUploads){
				fetch(`${this.$settings.APIBaseURL}/asset/upload`, {
					method: "post",
					body: data,
				})
				.then((result) => {
					if (result.status === 200) {
						result.json().then((json) => {
							if (json.status === "SUCCESS") {
								this.uploadedFiles = [...this.files];
								this.uploadHover = this.files;
								this.files = [];
								if (typeof this.modalSettings.uploadCallback === "function") {
									this.modalSettings.uploadCallback(this.uploadedFiles, json.result);
								}
							} else {
								this.errorFiles = [...this.files];
							}
						});
					}
				})
				.catch((error) => {
					this.$log.error.call(this, error);
				});
			}


			// Array.from(files).forEach(file => {
			// 	console.log("file", file);
			// 	this.files.push({
			// 		id: Date.now(),
			// 		name: file.name,
			// 		type: this.getFileType(file.name),
			// 		size: this.formatSizeUnits(file.size),
			// 		uploaded: false
			// 	});
			// });
		},
		getIconColor(fileName) {
			const fileNameArr = fileName.split(".");

			if (fileNameArr[1].toLowerCase() === "pdf") {
				return "file-icon file-icon-pdf mr-2";
			}

			if (fileNameArr[1].toLowerCase() === "doc" || fileNameArr[1].toLowerCase() === "docx") {
				return "file-icon file-icon-word mr-2";
			}

			if (
				fileNameArr[1].toLowerCase() === "jpeg" ||
				fileNameArr[1].toLowerCase() === "jpg" ||
				fileNameArr[1].toLowerCase() === "gif" ||
				fileNameArr[1].toLowerCase() === "png"
			) {
				return "file-icon file-icon-image mr-2";
			}

			return "file-icon file-icon-default mr-2";
		},
		getFileType(fileName) {
			const fileNameArr = fileName.split(".");

			if (fileNameArr[1].toLowerCase() === "pdf") {
				return "PDF";
			}

			if (fileNameArr[1].toLowerCase() === "doc" || fileNameArr[1].toLowerCase() === "docx") {
				return "Word";
			}

			if (
				fileNameArr[1].toLowerCase() === "jpeg" ||
				fileNameArr[1].toLowerCase() === "jpg" ||
				fileNameArr[1].toLowerCase() === "gif" ||
				fileNameArr[1].toLowerCase() === "png"
			) {
				return "Image";
			}

			return "File";
		},
		getFileIcon(fileName) {
			const fileNameArr = fileName.split(".");

			if (fileNameArr[1].toLowerCase() === "pdf") {
				return "file-earmark-richtext";
			}

			if (fileNameArr[1].toLowerCase() === "doc" || fileNameArr[1].toLowerCase() === "docx") {
				return "file-earmark-word";
			}

			if (
				fileNameArr[1].toLowerCase() === "jpeg" ||
				fileNameArr[1].toLowerCase() === "jpg" ||
				fileNameArr[1].toLowerCase() === "gif" ||
				fileNameArr[1].toLowerCase() === "png"
			) {
				return "file-earmark-image";
			}

			return "file-earmark";
		},
		formatSizeUnits(bytes) {
			if (bytes >= 1073741824) {
				bytes = (bytes / 1073741824).toFixed(2) + " GB";
			} else if (bytes >= 1048576) {
				bytes = (bytes / 1048576).toFixed(2) + " MB";
			} else if (bytes >= 1024) {
				bytes = (bytes / 1024).toFixed(2) + " KB";
			} else if (bytes > 1) {
				bytes = bytes + " bytes";
			} else if (bytes == 1) {
				bytes = bytes + " byte";
			} else {
				bytes = "0 bytes";
			}
			return bytes;
		},
		handleDragOver() {
			this.uploadHover = true;
		},
		handleDrop(e) {
			e.preventDefault();
			this.addFiles(e.dataTransfer.files);
		},
		handleDragLeave() {
			this.uploadHover = false;
		},
	},
	computed: {},
};
</script>
